import { render, staticRenderFns } from "./certAuditManage.vue?vue&type=template&id=47894082&scoped=true"
import script from "./certAuditManage.vue?vue&type=script&lang=js"
export * from "./certAuditManage.vue?vue&type=script&lang=js"
import style0 from "./certAuditManage.vue?vue&type=style&index=0&id=47894082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47894082",
  null
  
)

export default component.exports